<template>
  <div>
    <div class="main">
      <!-- 顶部广告条 -->
      <!-- <div class="topBanner">
        <img src="" alt />
        <span>广告</span>
      </div> -->
      <Topadv v-if="id" :keys="id" :advId="647"></Topadv>

      <!-- 阅读进入详情页面 -->
      <div class="breadcrumb" v-if="isRead">
        <span class="crumb" @click="
          $router.push({ path: '/read' });
        resetSetItem('isActive', 1);
        ">阅读</span>
        <span>></span>
        <span class="crumb" @click="goBack">{{ titleType }}</span>
        <span>></span>
        <span>{{ info.title }}</span>
      </div>
      <div class="breadcrumb" v-else>
        <span class="crumb" @click="
          $router.push({ path: '/' });
        resetSetItem('isActive', 0);
        ">首页</span>
        <span style="padding: 0 4px;">></span>
        <!-- 搜索页面进入详情页 -->
        <span v-if="isSearch" class="crumb" @click="
          $router.push({ name: 'search', params: { keyword: keyword } })
          ">搜索</span>
        <span v-if="isSearch">></span>
        <span>{{ info.title }}</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="banner" v-if="info.cover_url">
            <img :src="info.cover_url" alt />
          </div>
          <div class="info">
            <div class="info-top">
              <div class="message">
                <p>{{ info.title }}</p>
                <div class="mic" v-if="
                  info.article_type == 'sound' || info.article_type == 'voice'
                ">
                  <!-- <img src="@/assets/img/icon_mic.png" alt /> -->
                </div>
              </div>
              <div class="message">
                <div class="num">
                  <span>{{ info.display_time | timefilters }} ·
                    {{ info.read_time }}分钟阅读 · {{ info.word_times }}字</span>
                  <span class="laber" v-if="info.article_type == 'magazine'" @click="goLaber(info.column.id)">#{{
                    info.column.name }}</span>
                  <span class="laber" v-if="info.article_type == 'magazine'"
                    @click="goLaber(info.column.parent_column.id)">#{{ info.column.parent_column.name }}</span>
                  <!-- 普通文章 -->
                  <span class="laber" v-if="info.article_type == 'normal'" v-for="(item, i) in info.topics" :key="i"
                    @click="goLaber(item.id)">#{{ item.name }}</span>
                  <!--音频文章 -->
                  <span class="laber" v-if="
                    info.article_type == 'sound' ||
                    info.article_type == 'voice'
                  " v-for="(item, i) in info.really_tags" :key="i" @click="aboutLaber(item)">#{{ item }}</span>
                </div>
                <div class="num">
                  <div>
                    <img src="@/assets/img/like2.png" alt v-if="info.is_like" @click="praiseBtn" />
                    <img src="@/assets/img/like1.png" alt v-else @click="praiseBtn" />
                    <span>{{ info.like_times }}人点赞</span>
                  </div>
                  <div>
                    <img src="@/assets/img/collection1.png" alt v-if="info.is_favorited" @click="collectionBtn" />
                    <img src="@/assets/img/collection.png" alt v-else @click="collectionBtn" />
                    <span>{{ info.favorite_times }}人收藏</span>
                  </div>
                </div>
              </div>
              <!-- 单行本标题（只有单行本有，跳转付费单行本） -->
              <div class="summary">{{ info.summary }}</div>
              <div class="content" ref="myElement" :style="{ maxHeight: seeMoreHeight + 'px' }" v-html="info.content"
                v-if="info.is_jurisdiction == true">
                <!-- {{ info.content }} -->
              </div>
              <div v-else class="isJuris">
                <div style="text-align:left; margin:30px 0;" v-html="info.content"></div>
                <div style="text-align: center; color: gray; font-size: 18px; color: #0091ff;font-weight: 700; letter-spacing: 2px;">
                  --试读完毕，如需继续阅读请购买或订阅--
                </div>
                <div class="isJuris-title">
                  ///成为《第一财经》杂志订阅会员///
                </div>
                <div>
                  <p>第一时间获取最新杂志</p>
                  <p>每月先于纸刊发行，提前阅读杂志内容</p>
                </div>
                <div>
                  <p>解锁全部数字杂志</p>
                  <p>订阅后可阅读自创刊以来的全部杂志数字版</p>
                </div>
                <div>
                  <p>跨平台享受会员权益</p>
                  <p>使用订阅账号可在网站、APP享受相同权益</p>
                </div>
                <div>
                  <el-button @click="$router.push({ path: '/member' })">成为订阅会员</el-button>
                  <p v-if="showAvatar">
                    已是订阅会员？
                    <span @click="goLogin">登录</span>
                  </p>
                </div>
              </div>
              <div v-if="info.is_jurisdiction == true" class="more-intro-wrapper">

                <div @click="seeMore" v-if="isShowMore">///点击查看更多内容，或下载客户端/// <span><img src="../assets/img/down.png"
                      alt=""></span></div>
                <div @click="retract" v-else>收起</div>
                <div v-if="isShowMore" style="margin-top: 20px;"><img src="../assets/img/downloadApp.jpg" alt=""></div>

              </div>
              <div class="copyright">
                <span>本文版权归第一财经杂志所有</span>
                <br />
                <span>未经许可不得转载或翻译</span>
              </div>

              <DetailPagation :info="info" />

              <!-- <div class="praise">
                <img src="@/assets/img/icon_praise.png" alt v-if="info.is_favorited" />
                <img src="@/assets/img/icon_praise1.png" alt v-else />
                <p>{{info.like_times}}</p>
              </div>-->
              <!-- 普通文章投票 -->
              <!--去投票 -->
              <div v-if="info.article_type == 'normal' && voteList.length > 0">
                <div class="vote" style="margin-top:5%" v-if="voteList[0].is_done == false">
                  <p class="tit" v-if="voteList[0].category == 'simple'">
                    {{ voteList[0].title }}（单选）
                  </p>
                  <p class="tit" v-if="voteList[0].category == 'multiple'">
                    {{ voteList[0].title }}（多选）
                  </p>
                  <ul>
                    <li v-for="(item, i) in voteList[0].vote_items" :key="i">
                      <div class="img">
                        <img :src="item.cover_url" alt />
                      </div>
                      <div class="progress" style="padding: 0 20px" :class="checkoutList.indexOf(item) != -1 ||
                          radioList.indexOf(item) != -1
                          ? 'addClass'
                          : ''
                        ">
                        <div class="cont">
                          <p>{{ item.title }}</p>
                          <p>{{ item.summary }}</p>
                        </div>
                        <div class="per">
                          <input type="radio" name="1" v-if="voteList[0].category == 'simple'" class="radioBtn"
                            @change="changeRadio(item)" />
                          <input type="checkbox" v-if="voteList[0].category == 'multiple'" class="radioBtn"
                            @change="changeCheckout(item, i)" />
                        </div>
                      </div>
                    </li>
                  </ul>
                  <el-button class="voted bg-voted" @click="voteBtn">投票</el-button>
                </div>
                <!-- 完成投票 -->
                <div class="vote" style="margin-top:5%" v-if="voteList[0].is_done == true">
                  <p class="tit" v-if="voteList[0].category == 'simple'">
                    {{ voteList[0].title }}（单选）
                  </p>
                  <p class="tit" v-if="voteList[0].category == 'multiple'">
                    {{ voteList[0].title }}（多选）
                  </p>
                  <ul>
                    <li v-for="(item, i) in voteList[0].vote_items" :key="i">
                      <div class="img">
                        <img :src="item.cover_url" alt />
                      </div>
                      <div class="progress">
                        <div :style="'width:' + item.percent + '%'" :class="item.is_selected == true ? 'addClass' : 'otherClass'
                          ">
                          <div class="cont finshed">
                            <p>{{ item.title }}</p>
                            <p>{{ item.summary }}</p>
                          </div>

                          <div class="per perFinshed">{{ item.percent }}%</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <el-button class="voted">已投票</el-button>
                </div>
              </div>
              <div class="comment">
                <p class="title">评论</p>
                <div class="comment-box">
                  <div class="img">
                    <img src="@/assets/img/avatar.png" alt v-if="showAvatar" />
                    <img :src="avatar" alt v-else />
                    <!-- 用户头像 -->
                  </div>
                  <div class="commentInput">
                    <el-input type="textarea" :rows="5" v-model="commentCont" maxlength="200"
                      show-word-limit></el-input>
                    <div>
                      <el-button @click="publishBtn">发表</el-button>
                    </div>
                  </div>
                </div>
                <div>
                  <ul class="evaluate">
                    <li v-for="(item, i) in evaluateList" :key="i">
                      <div class="img" v-if="item.user">
                        <img :src="item.user.avatar" alt />
                      </div>
                      <div class="cont">
                        <p class="name" v-if="item.user">
                          {{ item.user.nickname }}
                        </p>
                        <p class="time">
                          {{ item.display_time | timefilters }}
                        </p>
                        <div>{{ item.content }}</div>
                      </div>
                      <div class="like">
                        <span>{{ item.like_times }}</span>
                        <img src="@/assets/img/like1.png" alt v-if="item.is_like == false"
                          @click="commentBtn(item.id, i)" />
                        <img src="@/assets/img/like2.png" alt v-else @click="commentBtn(item.id, i)" />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <!-- 右侧矩形广告 -->
          <!-- <div class="right-box">
              <div class="rightTop">
                <img width="100%" src="" alt="">
                <span>广告</span>
              </div>
            </div> -->

          <AboutAuthor :artAuthorList="authors"></AboutAuthor>
          <Rightadv v-if="id" :keys="id" :advId="652"></Rightadv>
          <div class="right-box" v-if="info.really_tags">
            <div class="top-laber" v-if="info.really_tags != ''">
              <p class="title">相关标签</p>
              <ul>
                <li v-for="(item, i) in info.really_tags" :key="i" @click="aboutLaber(item)">
                  <p>{{ item }}</p>
                </li>
              </ul>
            </div>
            <div class="top-laber" v-else>
              <p class="title">相关标签</p>
              <div style="line-height: 200px">暂无数据</div>
            </div>
          </div>
          <AboutArticle :child="id"></AboutArticle>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <LoginDialog :loginDialogs="loginDialogs" @child-event="getParentEvent"></LoginDialog>
  </div>
</template>
<script>
import { getone, advclick } from "@/api/adv";
import Topadv from "@/components/topadv";
import Rightadv from "@/components/rightadv";
import AboutAuthor from "@/components/aboutAuthor";
import AboutArticle from "@/components/aboutArticle";
import LoginDialog from "@/components/loginDialog";
import DetailPagation from "@/components/detailPagation.vue";
import {
  getFreeArticleDetail,
  getArticleComment,
  getArticleCommentCull,
  getCommentLike,
  getLike,
  getArctileLike,
  getCollection,
  getPublishComment,
  getVotes
} from "@/api/public";
import { getTdkList } from "@/api/tdk";
export default {
  components: {
    AboutAuthor,
    AboutArticle,
    LoginDialog,
    Rightadv,
    Topadv,
    DetailPagation
  },
  data() {
    return {
      authors: [],
      id: "",
      info: {},
      avatar: "@/assets/img/avatar.png",
      commentCont: "", //评价内容
      evaluateList: [],
      isLike: false,
      isCollection: false,
      // 弹框
      loginDialogs: false,
      showAvatar: true,
      voteList: [], //投票
      checkoutList: [],
      radioList: [],
      show: false,
      // 搜索页进入详情
      isSearch: false,
      keyword: "",
      // 阅读进入详情页
      isRead: false,
      titleType: "",
      readType: "",
      readId: "",
      readTypes: "",
      readCover: "",
      readTime: "",
      readSeria: "",
      seeMoreHeight: '360',
      isShowMore: true, // 默认不展开
    };
  },
  created() {
    getTdkList({ column: 0 }).then(res => {
      // console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title = res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  },
  methods: {
    zhushi() {
      // replaceAndSave(text, searchText,link) {
      //   let modifiedText = text; // 保存替换后的结果
      //   const regex = new RegExp(searchText, 'g'); // 创建正则表达式对象
      //   modifiedText = modifiedText.replace(regex, link); // 替换匹配到的内容
      //   return modifiedText; // 返回替换后的结果
      // }

      // for (var i = 0; i < this.Links.length; i++){
      //   console.log(this.Links.length)
      //     if(this.Links.length == 2){
      //       const textContent = this.replaceAndSave(res.data.data.content,this.Links[0].keyword,'<a href="'+this.Links[0].externalLink+'">唐四</a>')
      //       this.replaceText = this.replaceAndSave(textContent,this.Links[1].keyword,'<a href="'+this.Links[1].externalLink+'">院士</a>')
      //       // console.log(replaceText)
      //       console.log(this.replaceText)
      //     }

      // }
    },
    seeMore() {
      let totalHeight = this.$refs.myElement.scrollHeight;
      // console.log('totalHeight:', totalHeight); // 输出: totalHeight: 超过200px的值
      this.$nextTick(() => {
        // console.log(totalHeight)
        this.seeMoreHeight = totalHeight;
        this.isShowMore = false; // 切换isShowMore的值
      })
    },
    retract() {
      this.$nextTick(() => {
        this.seeMoreHeight = '360';
        this.isShowMore = true; // 切换isShowMore的值
      })
    },
    getList(id) {
      getFreeArticleDetail(id).then(res => {
        this.info = res.data.data;
        const {
          article_type,
          id,
          title,
          authors,
          display_time,
          read_time,
          topics,
          magazine,
          is_jurisdiction,
          really_tags,
          column,
          subject,
          summary
        } = this.info;
        let acname = "";
        switch (article_type) {
          case "magazine":
            acname = "杂志";
            break;
          case "subject":
            acname = "单行本";
            break;
          case "normal":
            acname = "资讯";
            break;
          case "radio":
            acname = "音频";
            break;
          case "theme":
            acname = "专题";
            break;

          default:
            break;
        }
        try {
          let defaultParams = [
            ["ptype", "detail"],
            ["pchannel", "webpc"],
            ["aaction", "pageview"],
            ["aid", this.info.id],
            ["atitle", title],
            ["aauthor", authors[0].name],
            ["atype", article_type === "radio" ? "radio" : "article"],
            ["aprod", "magazine"],
            ["actime", display_time],
            ["artime", read_time]
          ];

          if (article_type === "normal") {
            defaultParams.push(["acategory", "topic"], ["acname", "标签"]);
            if (topics) {
              defaultParams.push([
                "acategory2",
                topics.map(tag => {
                  return "topic" + tag.id;
                })
              ]);

              defaultParams.push([
                "atag",
                topics.map(tag => {
                  return tag.name;
                })
              ]);
            }

            defaultParams.push([
              "ac2name",
              topics.map(tag => {
                return tag.name;
              })
            ]);
          } else {
            defaultParams.push(["acategory", article_type], ["acname", acname]);

            if (magazine) {
              defaultParams.push(
                ["acategory2", article_type + magazine?.id],
                ["ac2name", magazine?.summary]
              );
            }

            if (subject) {
              defaultParams.push(
                ["acategory2", article_type + subject?.id],
                ["ac2name", subject?.summary]
              );
            }
          }

          if (column) {
            const { name, parent_column } = column;
            defaultParams.push([
              "atag",
              [column?.name, column?.parent_column?.name]
            ]);
          }

          // 实际未登录或无权限时传0，已登录且有权限时传1
          // info.is_jurisdiction == true;
          // if (this.info.is_jurisdiction) {
          //   var userInfo = localStorage.getItem("userInfo");
          //   if (userInfo) {
          //     defaultParams.push(["kpurchased", 1]);
          //   } else {
          //     defaultParams.push(["kpurchased", 2]);
          //   }
          // } else {
          //   defaultParams.push(["kpurchased", 0]);
          // }

          this.$ba(defaultParams);
        } catch (error) {
          console.log(error);
        }
        this.voteList = res.data.data.votes;
        const regex = new RegExp("<img", "gi");
        this.info.content = this.info.content.replace(
          regex,
          `<img style="width: 100%;"`
        );
        this.authors = res.data.data.authors;
        this.info.cover_url = this.info.cover_url.split(",");

        // console.log(res.data.data.topic)

        const head = document.getElementsByTagName('head')
        const meta = document.createElement('meta')

        if (res.data.data.topic != null) {
          document.title = res.data.data.topic;
        }
        if (res.data.data.keyword != null) {
          document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.keyword)
        }
        if (res.data.data.describe != null) {
          document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.describe)
        }
        head[0].appendChild(meta)

      });
    },
    commentBtn(id, i) {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        if (this.evaluateList[i].is_like) {
          this.evaluateList[i].like_times--;
        } else {
          this.evaluateList[i].like_times++;
        }
        this.evaluateList[i].is_like = !this.evaluateList[i].is_like;
        getCommentLike(id).then(res => { });
      }
    },
    // 收藏
    collectionBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        var type = "";
        if (
          this.info.article_type == "sound" ||
          this.info.article_type == "voice"
        ) {
          type = "AudioArticle";
        } else {
          type = "Article";
        }
        getCollection(this.id, type).then(res => {
          this.info.is_favorited = !this.info.is_favorited;
          if (this.info.is_favorited == true) {
            this.info.favorite_times += 1;
          } else {
            this.info.favorite_times -= 1;
          }
        });
      }
    },
    // 文章点赞
    praiseBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        getArctileLike(this.id).then(res => {
          this.info.is_like = !this.info.is_like;
          if (this.info.is_like == true) {
            this.info.like_times += 1;
          } else {
            this.info.like_times -= 1;
          }
        });
      }
    },
    // 发表评论
    publishBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        var type = "";
        if (
          this.info.article_type == "sound" ||
          this.info.article_type == "voice"
        ) {
          type = "AudioArticle";
        } else {
          type = "Article";
        }
        var params = {
          content: this.commentCont,
          article_type: type
        };
        getPublishComment(this.id, params).then(res => {
          this.commentCont = "";
          this.$message.success("发表成功");
        });
      }
    },
    // 弹框
    getParentEvent(data) {
      this.loginDialogs = data;
    },
    // 热门标签
    goLaber(id) {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        name: "hot_laber",
        params: {
          id: id,
          type: this.info.article_type,
          isSearch: this.isSearch,
          keyWord: this.keyword,
          articleTitle: this.info.title,
          articleId: this.id
        }
      });
    },
    // 相关标签跳标签列表页
    aboutLaber(item) {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        name: "hot_laber",
        params: {
          name: item,
          isSearch: this.isSearch,
          keyWord: this.keyword,
          articleTitle: this.info.title,
          articleId: this.id
        }
      });
    },
    // 去投票
    voteBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        if (this.radioList.length <= 0 && this.checkoutList.length <= 0) {
          this.$message.error("请选择");
        } else {
          var params = {
            id: this.voteList[0].id,
            category: "",
            vote_item_ids: []
          };
          if (this.radioList.length != 0) {
            params.category = "simple";
            params.vote_item_ids.push(this.radioList[0].id);
          } else if (this.checkoutList.length != 0) {
            params.category = "multiple";
            var newArray = [];
            for (var j in this.checkoutList) {
              newArray.push(this.checkoutList[j].id);
            }
            params.vote_item_ids = newArray;
          }
          var votes = [];
          votes.push(params);
          var newVote = {
            votes: votes
          };
          getVotes(newVote, this.id).then(res => {
            this.$message.success("投票成功");
            this.voteList = res.data.data;
          });
        }
      }
    },
    // 单选
    changeRadio(item) {
      if (this.radioList.length == 0) {
        this.radioList.push(item);
      } else {
        this.radioList.splice(0, 1);
        this.radioList.push(item);
      }
    },
    // 多选
    changeCheckout(item, i) {
      if (event.target.checked == true) {
        this.checkoutList.push(item);
      } else {
        for (var i in this.checkoutList) {
          if (item.title == this.checkoutList[i].title) {
            this.checkoutList.splice(i, 1);
          }
        }
      }
    },
    // 登录（没有会员权限，且没有登录）
    goLogin() {
      this.loginDialogs = true;
    },
    // 阅读返回上一层
    goBack() {
      if (this.readType == "free") {
        //免费单行本
        this.$router.push({
          name: "read_free",
          params: {
            id: this.readId,
            type: this.readTypes,
            title: this.titleType,
            cover: this.readCover,
            time: this.readTime,
            seria: this.readSeria
          }
        });
      } else if (this.readType == "charge") {
        this.$router.push({
          name: "read_detail",
          params: {
            id: this.readId,
            type: this.readTypes
            // readId: this.id,
            // readTypes: this.type
          }
        });
      } else {
        this.$router.push({
          name: "magalog",
          params: {
            id: this.readId,
            type: this.readTypes,
            title: this.titleType,
            cover: this.readCover,
            time: this.readTime,
            seria: this.readSeria
          }
        });
      }
    },
    //右侧广告跳转
    rightAdvClick(data, url) {
      advclick(
        data,
        "article",
        this.info.article_type + "[" + this.id + "]",
        this.id
      );
      window.open(url, "_blank");
    },
    //顶部广告跳转
    topAdvClick(data, url) {
      advclick(
        data,
        "article",
        this.info.article_type + "[" + this.id + "]",
        this.id
      );
      window.open(url, "_blank");
    }
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.id = newVal.params.id;
        // 搜索页进入详情
        this.keyword = newVal.params.keyWord;
        this.isSearch = newVal.params.isSearch;
        // 阅读进入详情页
        this.isRead = newVal.params.isRead;
        this.titleType = newVal.params.titleType;
        this.readType = newVal.params.readType;
        this.readId = newVal.params.readId;
        this.readTypes = newVal.params.readTypes;
        this.readCover = newVal.params.readCover;
        this.readTime = newVal.params.readTime;
        this.readSeria = newVal.params.readSeria;
        // if (this.$route.params.isSearch != undefined) {
        //   //搜索页进入详情
        //   this.isSearch = true;
        // }
        this.resetParams(this, [
          "isRead",
          "isSearch",
          "keyword",
          "titleType",
          "readType",
          "readId",
          "readTypes",
          "readCover",
          "readTime",
          "readSeria"
        ]);
        this.getList(this.id);
        if (localStorage.getItem("Authorization") != null) {
          var userInfo = JSON.parse(localStorage.getItem("userInfo"));
          this.avatar = userInfo.avatar;
          this.showAvatar = false;
        }
        // 精选评论
        getArticleComment(this.id).then(res => {
          this.evaluateList = res.data.data;
        });
        this.$nextTick(() => {
          // 禁用右键
          document.oncontextmenu = new Function("event.returnValue=false");
          // 禁用选择
          document.onselectstart = new Function("event.returnValue=false");
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  display: flex;

  .crumb {
    cursor: pointer;
  }

  span:last-child {
    color: #0091ff;
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // width: 80px;
  }
}

.banner {
  width: 100%;
  max-height: 480px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    vertical-align: bottom;
  }
}

.info {
  padding: 30px 30px 20px 30px;
  background: #ffffff;
  margin-bottom: 60px;

  .info-top {
    .message {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        font-size: 30px;
        font-weight: bold;
      }

      .mic {
        img {
          width: 100%;
        }
      }

      .num {
        display: flex;
        font-size: 14px;
        color: #999999;
        line-height: 42px;
        align-items: center;

        .laber {
          color: #0091ff;
          margin-left: 30px;
          cursor: pointer;
        }

        div {
          margin-left: 30px;

          img {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 4px;
          }

          span {
            vertical-align: middle;
          }
        }
      }

      .num:nth-child(2) {
        cursor: pointer;
      }
    }

    .summary {
      color: #999999;
      font-size: 18px;
      line-height: 42px;
    }

    .content {
      font-size: 18px;
      line-height: 36px;
      margin-top: 10px;
      text-align: justify;
      white-space: pre-wrap;
      // max-height: 360px;
      overflow: hidden;
      -webkit-transition: all .3s ease;
      -o-transition: all .3s ease;
      transition: all .3s ease;

      >>>figcaption {
        text-align: center;
        color: #999999;
        margin-bottom: 10px;
      }
    }

    .isJuris {
      text-align: center;

      .isJuris-title {
        color: #0091ff;
        font-size: 24px;
        font-weight: 700;
      }

      div {
        margin: 64px 0;

        p {
          font-size: 16px;
          line-height: 30px;

          span {
            color: #0091ff;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        p:nth-child(1) {
          font-size: 20px;
          font-weight: 700;
        }

        .el-button {
          background: #fff;
          color: #0091ff;
          font-size: 18px;
          border: 1px solid #0091ff;
          margin-bottom: 10px;
          width: 200px;
          border-radius: 23px;
        }
      }
    }

    .praise {
      margin-top: 40px;
      text-align: center;
      font-size: 18px;
      color: #999999;
      cursor: pointer;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 20px;
    }

    .comment {
      border-top: 1px solid #eeeeee;

      .title {
        margin: 25px 0;
        font-size: 16px;
        font-weight: 600;
      }

      .comment-box {
        display: flex;

        .img {
          margin-right: 20px;
          width: 8%;

          img {
            width: 100%;
            border-radius: 50%;
            min-height: 57px;
          }
        }

        .commentInput {
          width: 100%;

          >>>.el-textarea__inner {
            border-radius: 0;
          }

          >>>.el-textarea .el-input__count {
            color: #999999;
            background: #fff;
            position: absolute;
            font-size: 14px;
            bottom: -38px;
            left: 0px;
            width: 40px;
          }

          div {
            margin-top: 12px;
            text-align: right;

            .el-button {
              border-radius: 18px;
              width: 90px;
              height: 36px;
              padding: 0;
              background: #0091ff;
              color: #fff;
              border: none;
            }
          }
        }
      }

      .evaluate {
        li {
          display: flex;
          border-bottom: 1px solid #eeeeee;
          padding-bottom: 60px;
          margin-top: 30px;
          position: relative;

          .img {
            width: 7%;
            height: 7%;
            margin-right: 20px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              min-height: 55px;
            }
          }

          .cont {
            width: 80%;
            font-size: 16px;

            .name {
              line-height: 36px;
              font-weight: 500;
            }

            .time {
              font-size: 14px;
              color: #999999;
            }

            div {
              line-height: 30px;
              margin-top: 10px;
            }
          }

          .like {
            width: 10%;
            position: absolute;
            bottom: 30px;
            right: 0;
            text-align: right;

            span {
              margin-right: 6px;
              color: #999999;
              font-size: 14px;
              vertical-align: middle;
            }

            img {
              vertical-align: middle;
            }
          }
        }

        li:last-child {
          padding-bottom: 30px;
          border-bottom: none;
          margin-bottom: 10px;

          .like {
            bottom: 0;
          }
        }
      }
    }
  }
}

.right-box {
  background: #ffffff;
  margin-bottom: 30px;

  .top-laber {
    text-align: center;
    padding: 30px 10px;
    box-sizing: border-box;

    .title {
      font-weight: 600;
      line-height: 24px;
      font-size: 16px;
    }

    ul {
      text-align: left;
      padding: 0;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;

      li {
        list-style-type: none;
        border: 1px solid #0091ff;
        border-radius: 18px;
        padding: 0px 10px;
        color: #0091ff;
        font-size: 16px;
        margin-right: 20px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }

    .tit {
      font-size: 16px;
      font-weight: bold;
    }

    .laber-info {
      margin-top: 12px;
      padding: 0 30px 20px 30px;

      p {
        font-size: 16px;
        color: #0091ff;
        line-height: 32px;
      }

      div {
        font-size: 12px;
        color: #999999;
      }

      .intro {
        line-height: 43px;
        font-size: 14px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .el-button {
        width: 80px;
        height: 30px;
        padding: 0;
        border-radius: 15px;
        background: #0091ff;
        color: #fff;
      }

      .follow {
        background: #ffffff;
        color: #0091ff;
        border: 1px solid;
      }
    }
  }
}

.vote {
  text-align: center;

  .tit {
    font-size: 20px;
    font-weight: bold;
    line-height: 36px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: left;
  }

  ul {
    text-align: left;

    li {
      display: flex;
      height: 120px;
      margin-bottom: 20px;

      .img {
        width: 150px;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        line-height: 150px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .progress {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        border: 1px solid #eee;
        position: relative;

        .cont {
          p {
            color: #999999;
            font-size: 18px;
            line-height: 36px;
          }

          p:nth-child(1) {
            color: #0091ff;
            font-size: 20px;
          }
        }

        .per {
          color: #0091ff;
          font-size: 20px;

          .radioBtn {
            width: 25px;
            height: 25px;
            opacity: 0.8;
          }
        }

        .finshed {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translate(0, -50%);
        }

        .perFinshed {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
    }

    .addClass {
      background: #d8eeff;
      height: 100%;
      border: 1px solid #d8eeff;
    }

    .otherClass {
      background: #eeeeee;
      height: 100%;
    }
  }

  .voted {
    width: 300px;
    border-radius: 23px;
    color: #0091ff;
    border: 1px solid;
    background: #fff;
    font-size: 16px;
    margin: 50px 0;
    cursor: auto;
  }

  .bg-voted {
    background: #0091ff;
    color: #fff;
    cursor: pointer;
  }
}

.copyright {
  font-size: 14px;
  color: #999;
  margin-top: 60px;
  text-align: center;
  line-height: 30px;
  margin-bottom: 30px;
}

.topBanner {
  position: relative;
  margin: 30px 0;
  display: block;
  // border: 1px solid;
  background: #fff;
  height: 90px;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}

.rightTop {
  position: relative;
  width: 320px;
  height: 250px;
  background: #fff;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}

.more-intro-wrapper {
  position: relative;
  padding-top: 20px;
  text-align: center;
  color: #a3a3ac;
  font-size: 14px;
  letter-spacing: 1.4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/articleDetail.vue